// validators.ts
import { allowAdditionalProperties, arrayOf, boolean, date, object, oneOf, optional, string } from "justus";
import { uuid } from "justus/extra/uuid";
var addressType = oneOf("shipping", "billing");
var validationStatus = oneOf("valid", "invalid", "corrected");
var validationDetails = oneOf("invalid_postal_code", "invalid_city", "invalid_street", "city_corrected", "street_corrected", "postal_code_corrected", "house_number_corrected", "house_number_missing", "house_number_not_recognized");
var metadata = {
  verified_with: optional(string),
  details: optional(arrayOf(validationDetails)),
  ...allowAdditionalProperties
};
var placeValidator = object({
  country: optional(string({ minLength: 2, maxLength: 2 }), "DE"),
  street_name: string({ minLength: 1 }),
  house_number: string({ minLength: 1 }),
  postal_code: string({ maxLength: 5 }),
  city: string({ minLength: 1 }),
  metadata: optional(metadata)
});
var validateAddressRequestValidator = object({
  google_place_id: optional(string),
  ...placeValidator
});
var validateAddressResponseValidator = object({
  checked: boolean,
  status: oneOf("valid", "slightly_corrected", "significantly_corrected", "invalid"),
  details: optional(arrayOf(validationDetails)),
  address: placeValidator
});
var addressValidator = object({
  uuid,
  created: date({ format: "iso" }),
  modified: date({ format: "iso" }),
  user_uuid: uuid,
  ...placeValidator,
  given_name: string,
  family_name: string,
  phone: string,
  type: addressType,
  default: boolean,
  address_extra: optional(string),
  company: optional(string),
  vat: optional(string),
  deleted: optional(boolean)
});
var updateAddressValidator = object({
  default: boolean
});
var contact = object({
  given_name: string,
  family_name: string,
  phone: string,
  address_extra: optional(string),
  company: optional(string)
});
var createBillingAddressValidator = object({
  google_place_id: optional(string),
  /* Admin users can create an address for another user, thus we need this field */
  user_uuid: optional(uuid),
  ...placeValidator,
  ...contact,
  type: "billing",
  default: boolean,
  vat: optional(string)
});
var createShippingAddressValidator = object({
  google_place_id: optional(string),
  /* Admin users can create an address for another user, thus we need this field */
  user_uuid: optional(uuid),
  ...placeValidator,
  ...contact,
  type: "shipping",
  default: boolean,
  skip_validation: optional(boolean)
});
var createAddressValidator = oneOf(createBillingAddressValidator, createShippingAddressValidator);
export {
  addressType,
  addressValidator,
  createAddressValidator,
  placeValidator,
  updateAddressValidator,
  validateAddressRequestValidator,
  validateAddressResponseValidator,
  validationDetails,
  validationStatus
};
//# sourceMappingURL=validators.mjs.map
